<script setup lang="ts">
import { ref, useTemplateRef } from 'vue';
import OverlayPanel from 'primevue/overlaypanel';
import { capitalizeStr } from '@Helpers';

defineProps<{
  field: any;
  isAside?: boolean;
  oddRow?: boolean;
  rowData: any;
  settings: any;
}>();

const extraInfoPanel = useTemplateRef<InstanceType<typeof OverlayPanel> | null>('extraInfoPanel');
const isHovering = ref(false);

function showPanel(event: any) {
  isHovering.value = true;
  extraInfoPanel.value?.show(event);
}

function hidePanel() {
  extraInfoPanel.value?.hide();
}
</script>

<template>
  <span
    v-if="!field || !field.length"
    class="flex flex-col items-start gap-0.5"
  >
    -
  </span>

  <div
    v-else
    class="relative flex w-full max-w-80 items-start gap-0.5 overflow-hidden bg-transparent"
    @mouseenter="showPanel"
    @mouseleave="hidePanel"
  >
    <Tag
      v-for="hold in field"
      :class="[
        'w-fit rounded-lg bg-slate-400 text-[12px] font-semibold',
        hold.color === '#F5F7F8' ? 'text-gray-700' : 'text-white',
      ]"
      :key="hold.history_record_id.$oid"
      :value="capitalizeStr(hold.label || '')"
      :style="{
        'background-color': hold.color || '#8B949E',
      }"
    />
    <div
      v-if="field.length > 2"
      class="absolute right-0 h-10 w-10 bg-gradient-to-r from-transparent to-white"
    />

    <OverlayPanel ref="extraInfoPanel">
      <div class="flex max-w-64 flex-wrap gap-1">
        <Tag
          v-for="tag in field"
          :class="[
            'w-fit rounded-lg bg-slate-400 text-[12px] font-semibold',
            tag.color === '#F5F7F8' ? 'text-gray-700' : 'text-white',
          ]"
          :key="tag.history_record_id.$oid"
          :value="capitalizeStr(tag.label || '')"
          :style="{
            'background-color': tag.color || '#8B949E',
          }"
        />
      </div>
    </OverlayPanel>
  </div>
</template>
